// // src/store/slices/allBillingSlice.js
// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//     limit: 10,
//     page: 1,
//     search: '',
//     sortValue: -1,
//     startDate: '',
//     endDate: '',
//     selectedSortBy: [],
//     selectedGenderBy: [],
//     selectedRatingBy: [],
//     selectedPaymentMethods: [],
//     selectedServices: [],
//     selectedServiceProviders: [],
//     selectedProducts: [],
//     dues: false,
//     billType: 'Bill',
// };

// const allBillingSlice = createSlice({
//     name: 'allBilling',
//     initialState,
//     reducers: {
//         setBillingFilter: (state, action) => {
//             return { ...state, ...action.payload };
//         },
//         resetBillingFilters: () => initialState,
//         // Add this new action
//         resetBillingSearchAndFilters: (state) => {
//             return {
//                 ...state,
//                 search: '',
//                 startDate: '',
//                 endDate: '',
//                 selectedSortBy: [],
//                 selectedGenderBy: [],
//                 selectedRatingBy: [],
//                 selectedPaymentMethods: [],
//                 selectedServices: [],
//                 selectedServiceProviders: [],
//                 selectedProducts: [],
//                 dues: false,
//                 page: 1,
//             };
//         },
//         setBillingPage: (state, action) => {
//             state.page = action.payload;
//         },
//         setBillingLimit: (state, action) => {
//             state.limit = action.payload;
//             state.page = 1;
//         },
//         toggleDuesFilter: (state) => {
//             state.dues = !state.dues;
//             state.page = 1; // Reset to first page when changing filter
//         }
//     },
// });

// export const {
//     setBillingFilter,
//     resetBillingFilters,
//     resetBillingSearchAndFilters, // Export the new action
//     setBillingPage,
//     setBillingLimit,
//     toggleDuesFilter
// } = allBillingSlice.actions;
// export default allBillingSlice.reducer;
// src/store/slices/allBillingSlice.js


import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    limit: 10,
    page: 1,
    search: '',
    sortValue: -1,
    startDate: '',
    endDate: '',
    selectedSortBy: [],
    selectedGenderBy: [],
    selectedRatingBy: [],
    selectedPaymentMethods: [],
    selectedServices: [],
    selectedServiceProviders: [],
    selectedProducts: [],
    dues: false,
    availability: false,
    billType: 'Bill',
};

const allBillingSlice = createSlice({
    name: 'allBilling',
    initialState,
    reducers: {
        setBillingFilter: (state, action) => {
            return { ...state, ...action.payload };
        },
        resetBillingFilters: () => initialState,
        // Add this new action
        resetBillingSearchAndFilters: (state) => {
            return {
                ...state,
                search: '',
                startDate: '',
                endDate: '',
                selectedSortBy: [],
                selectedGenderBy: [],
                selectedRatingBy: [],
                selectedPaymentMethods: [],
                selectedServices: [],
                selectedServiceProviders: [],
                selectedProducts: [],
                dues: false,
                availability: false,
                page: 1,
            };
        },
        setBillingPage: (state, action) => {
            state.page = action.payload;
        },
        setBillingLimit: (state, action) => {
            state.limit = action.payload;
            state.page = 1;
        },
        toggleDuesFilter: (state) => {
            state.dues = !state.dues;
            state.page = 1; // Reset to first page when changing filter
        },
          toggleAvailabilityFilter: (state) => { // Add this new action
            state.availability = !state.availability;
            state.page = 1;
        }
    },
});

export const {
    setBillingFilter,
    resetBillingFilters,
    resetBillingSearchAndFilters, // Export the new action
    setBillingPage,
    setBillingLimit,
    toggleDuesFilter,
    toggleAvailabilityFilter 
} = allBillingSlice.actions;
export default allBillingSlice.reducer;
